<app-popup-layout #modal>
  <!-- <header class="modal-header">
    <app-close-button
      class="ms-auto"
      (onCloseEmitter)="modal.dismiss()"
    ></app-close-button> -->
  <!-- </header> -->
  <div class="modal-container p-5">
    <p class="title">Create Meal Card Account</p>
    <img
      src="assets/home/meal-account-create.png"
      class="enkash-card mt-12 mb-4"
      alt="Enkash Card Account"
    />
    <section class="w-100" [formGroup]="form">
      <div class="d-flex flex-col mt-8">
        <label class="input-label m-0">Account Title</label>
        <input
          class="px-3"
          type="text"
          placeholder="Account Title"
          class="form-control"
          formControlName="accountTitle"
        />
      </div>

      <section class="d-flex mt-32 justify-center align-content-center">
        <button
          mat-flat-button
          color="accent"
          class="me-4"
          (click)="modal.dismiss()"
        >
          I'll Create Later
        </button>

        <button
          mat-flat-button
          color="primary"
          [appLoaderButton]="formActionRequestState()"
          [disabled]="form.invalid"
          (click)="onSave()"
        >
          Confirm & Continue
        </button>
      </section>
    </section>
  </div>
</app-popup-layout>
